export default "__VITE_ASSET__aefdf475__"